<template lang="pug">
v-card.sdo-radius.overflow-auto
  v-toolbar(tile flat)
    v-card-title.ml-n3 Выгрузка удостоверений
    v-spacer

  v-card-text.px-0
    v-window.px-4(v-model="window")
      v-window-item
        export-list(v-if="window === 0")
        .d-flex.mt-4
          v-spacer
          v-btn(
            v-if="window === 0"
            color="primary" large
            @click="window += 1" depressed
          ) Сформировать выгрузку
            v-icon(right) mdi-chevron-right
      v-window-item
        v-sheet(flat height="260").align-content-center.px-2
          .text-body-2.mb-2: strong Выберите тип выгрузки:
          v-list
            v-list-item-group(v-model="exportType")
              v-list-item.grey.lighten-3.mb-4.py-2(
                active-class="secondary darken-1 white--text"
                :value="1"
              )
                template(#default="{ active }")
                  v-list-item-avatar.mr-2: v-icon(
                    :color="active ? 'white' : 'secondary'"
                  ) {{ !active ? 'mdi-radiobox-blank' : 'mdi-radiobox-marked'}}
                  v-list-item-title: strong Реестр для ФИС ФРДО
              v-list-item.grey.lighten-3.py-2(
                active-class="secondary darken-1 white--text"
                :value="2"
              )
                template(#default="{ active }")
                  v-list-item-avatar.mr-2: v-icon(
                    :color="active ? 'white' : 'secondary'"
                  ) {{ !active ? 'mdi-radiobox-blank' : 'mdi-radiobox-marked'}}
                  v-list-item-title: strong Журнал выдачи удостоверений

        .d-flex.mt-4
          v-btn(
            depressed large color=""
            @click="window -= 1"
          ).px-8 Назад
          v-spacer
          v-btn(
            depressed large color="success"
            :disabled="!exportType"
            @click="window += 1"
          ).px-8 Продолжить
      v-window-item
        .text-body-2.mb-2: strong Укажите период выгрузки:
        .text-body-2 от:
        sdo-datetime-field(
          v-model="start"
          only-date large
          :date-props="{ height: 60, filled: true, solo: true, flat: true }"
        )
        .text-body-2 до:
        sdo-datetime-field(
          v-model="end"
          only-date :date-props="{ height: 60, filled: true, solo: true, flat: true }"
        )

        .d-flex.mt-4
          v-btn(
            depressed large color=""
            @click="window -= 1"
          ).px-8 Назад
          v-spacer
          v-btn(
            depressed large color="success"
            :loading="loading"
            :disabled="!(start && end)"
            @click="exportList"
          ).px-8 Выгрузить
</template>
<script>
import ExportList from '@/components/ExportList.vue';

export default {
  components: {
    ExportList,
  },
  data() {
    return {
      queryParams: null,
      window: 0,
      tab: 0,
      start: null,
      end: null,
      loading: false,
      exportType: null,
    };
  },

  methods: {
    async exportList() {
      this.loading = true;
      const { start, end, exportType } = this;
      const byType = {
        1: {
          name: 'Реестр',
          method: 'exportFisFrdo',
          // type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
        2: {
          name: 'Журнал выдачи',
          method: 'exportJournal',
          // type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        },
      };
      await this.$api.diploma[byType[exportType].method]({ start, end });

      // const link = document.createElement('a');
      // const blob = new Blob([data], { type: byType[exportType].type });
      // const objectUrl = URL.createObjectURL(blob);
      // link.href = objectUrl;
      // link.download = byType[exportType].name;
      // link.click();
      this.window = 0;
      this.loading = false;
    },

  },
};
</script>
